import React, { useEffect } from "react";
import Footer from "./Footer";
import CustomHeading from "../components/custom/CustomHeading"

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);
  return (
    <div className="px-[6%] lg:px-[8%] py-[3%]">
      <CustomHeading smTextSize="30px" textSize="60px" textColor="#d31c4f" thirdTextColor="#d31c4f" leading={window.innerWidth < 450 ? "40px":"72px"} marginTop={"32px"} text={"Terms & Conditions Mother"} spanText={"'"} secondFontStyle="font-Lato" thirdText={"s Pride Preschool"}/>
      <h2 className="mt-3 font-semibold">Last Updated: April 2025</h2>
      <p className="mt-2 text-lg">
        These terms take effect with the use of this website and these services.
      </p>
      <div className="flex flex-col gap-4 mt-8">
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold text-lg">1. Admissions & Fees</h1>
          <div>
            <p className="mt-[2px]">
              - Admission at school is only permissible to those who qualify as
              per criteria that the school has set and who have not yet
              exhausted the available seats.
            </p>
            <p className="mt-[2px]">
              - Fees are to be paid as specified within the deadlines. Paying
              the fees after the deadline may attract extra costs.
            </p>
            <p className="mt-[2px]">
              - Fees, except under some conditions, are non-refundable.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold text-lg">2. Code of Conduct </h1>
          <div>
            <p className="mt-[2px]">
              - Students, parents, and staff alike are obliged to conduct
              themselves respectfully.
            </p>
            <p className="mt-[2px]">
              - Failure to comply with our policies, rules, or other negative
              behaviors may result in the termination of our services to them.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold text-lg">3. Health & Safety </h1>
          <div>
            <p className="mt-[2px]">
              - Parents need to identify any underlying conditions that their
              child has or any special educational needs.
            </p>
            <p className="mt-[2px]">
              - We have a track record of applying safety measures, and in case
              of emergencies, actions will be executed as deemed fit.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold text-lg">4. Privacy & Website Usage </h1>
          <div>
            <p className="mt-[2px]">
              - The policy authorizes personally identifiable information to be
              shared in accordance with the Privacy Policy.
            </p>
            <p className="mt-[2px]">
              - Photos and videos can be taken and later used for marketing
              purposes, unless specified otherwise.
            </p>
            <p className="mt-[2px]">
              - Content owned by ​Mother’s Pride Preschool​ cannot be duplicated
              or infringed in any manner.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold text-lg">5. Liability & Termination </h1>
          <div>
            <p className="mt-[2px]">
              - We shall not hold responsibility for any unexpected events that
              happen without our influence.
            </p>
            <p className="mt-[2px]">
              - Clients that fail to meet the basic requirements or deadlines
              may have their access to our services revoked.
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col mt-7 gap-2">
        <p className="font-medium mt-1">For queries, contact us:</p>
        <p>📞 917290011862 | ✉️ info@motherspridepreschool.com </p>
        <p>🌐 https://www.motherspridepreschool.com/</p>
      </div>
      <Footer marginX={"0%"} />
    </div>
  );
};

export default TermsConditions;
